export enum SecurityGroupAccessType {
  Profile,
  Role,
}
export enum SecurityGroupDialogTarget {
  Profile,
  Access,
}
